import {Controller} from "@hotwired/stimulus"
import {formValidation, plugins} from "../../../../vendor/javascript/@form-validation/esm/bundle/popular"
import * as Bootstrap5 from "../../../../vendor/javascript/@form-validation/esm/plugin-bootstrap5/index.js"

// Connects to data-controller="validators--register"
export default class extends Controller {
    connect() {
        console.log('RegisterController connected');
        this.initializeValidation();
    }

    initializeValidation() {
        const form = document.getElementById('frm-account-register');
        if (!form) {
            console.error('Register form element not found');
            return;
        }

        // Initialize form validation
        this.validation = formValidation(form, {
            fields: {
                'user[first_name]': {
                    validators: {
                        notEmpty: {
                            message: 'First name is required'
                        },
                        stringLength: {
                            min: 2,
                            max: 50,
                            message: 'First name must be between 2 and 50 characters'
                        }
                    }
                },
                'user[last_name]': {
                    validators: {
                        notEmpty: {
                            message: 'Last name is required'
                        },
                        stringLength: {
                            min: 2,
                            max: 50,
                            message: 'Last name must be between 2 and 50 characters'
                        }
                    }
                },
                'user[email]': {
                    validators: {
                        notEmpty: {
                            message: 'Email address is required'
                        },
                        emailAddress: {
                            message: 'Please enter a valid email address'
                        }
                    }
                },
                'user[password]': {
                    validators: {
                        notEmpty: {
                            message: 'Password is required'
                        },
                        stringLength: {
                            min: 6,
                            message: 'Password must be at least 6 characters long'
                        }
                    }
                },
                'user[password_confirmation]': {
                    validators: {
                        notEmpty: {
                            message: 'Password confirmation is required'
                        },
                        identical: {
                            compare: function () {
                                return form.querySelector('[name="user[password]"]').value;
                            },
                            message: 'The password and its confirmation are not the same'
                        }
                    }
                }
            },
            plugins: {
                trigger: new plugins.Trigger({
                    event: 'blur'
                }),
                submitButton: new plugins.SubmitButton(),
                bootstrap5: new Bootstrap5.Bootstrap5({
                    rowSelector: '.form-floating',
                    eleInvalidClass: 'is-invalid',
                    eleValidClass: 'is-valid'
                })
            }
        })
            .on('core.form.valid', function (e) {
                form.submit();
            })
            .on('core.form.invalid', function (e) {
                // console.log('Form is invalid!');
            });

        // Revalidate password_confirmation when password changes
        form.querySelector('[name="user[password]"]').addEventListener('input', () => {
            this.validation.revalidateField('user[password_confirmation]');
        });
    }

    disconnect() {
        if (this.validation) {
            this.validation.destroy();
        }
    }
}
